
import axios from 'axios'
import config from '@/config'

//const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

//Vue.prototype.$axios = axios//和export default axios一样

axios.defaults.timeout = 50000;
//xios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;';
//'application/json;charset=utf-8';//

axios.defaults.baseURL = config.baseUrl

// 刷新 access_token 的接口
const refreshToken = (isLoginPage) => {
    let _token=$httpVue.$store.getters.getRefreshToken();
    //if(_token)
    return axios.post('/api/AccessToken/Refresh', { Token: _token },isLoginPage)
}

axios.interceptors.request.use(config => {
    // 携带上token

    let token = $httpVue.$store.getters.getToken();
    token && (config.headers.Authorization = token);
    return config;
}, error => {
    return Promise.reject(error);
});
let isLoginPage=true//如果需要登录是否要跳转登录页
let isRefreshing = false // 标记是否正在刷新 token
let requests = [] // 存储待重发请求的数组
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (!error.response) {
        console.log("服务器(failed)");//请求连接访问不到时会在这里显示
        return Promise.reject(error)
    }
    if (error.response.status === 401 ) {
        const { config } = error
        //console.log("config",config)
        if (!isRefreshing) {
            isRefreshing = true
            return refreshToken(isLoginPage).then(res=> {
                let reslut=res.data
                if(reslut.code==200)
                {
                    $httpVue.$store.commit('setUserInfo', reslut.data);
                    config.headers.Authorization = 'Bearer ' + reslut.data.accessToken;
                    console.log("前requests.forEach",requests)
                    // token 刷新后将数组的方法重新执行
                    requests.forEach((cb) => cb(reslut.data.accessToken))
                    console.log("后requests.forEach",requests)
                    requests = [] // 重新请求完清空
                    return axios(config)
                }
                else
                {
                    return Promise.reject(reslut);//由下面catch接收
                }
            }).catch(err => {
                //console.log(error.response)
                //只有会员中心不需要返回处理。
                //console.log("这是",isLoginPage)
                //isLoginPage默认为true，如果为真就跳到登录页，否则不跳转页面
                if(isLoginPage){
                    $httpVue.$router.push({ path: '/login', params: { r: Math.random() } });
                }
                isLoginPage=true
                $httpVue.$store.commit('clearUserInfo');
                return Promise.reject(err);//返回到请求页异常处理
            }).finally(() => {
                isRefreshing = false
            })
        } else {
            // 返回未执行 resolve 的 Promise
            console.log("获得数据5---------")
            return new Promise(resolve => {
                // 用函数形式将 resolve 存入，等待刷新后再执行
                requests.push(token => {
                    config.headers.Authorization = `Bearer ${token}`
                    resolve(axios(config))
                })  
            })
        }
    }
    return Promise.reject(error)
})
/* axios.interceptors.response.use((res) => {
    //_showLoading && loading.close();
    //对响应数据做些事
    if (res.data.success) {
        return res;
    }
    return Promise.resolve(res);
}, (error) => {
    //_showLoading && loading.close();
    let httpMessage = '';
    if (error.response.data && error.response.data.message) {
        httpMessage = error.response.data.message;
    } else if (error.response.status == '404') {
        httpMessage = "没有找到请求的地址";
    } else {
        httpMessage = '网络好像出了点问题~'
    }

    //redirect(error.response, httpMessage);
    return Promise.reject(error.response);
}); */

function post(url, params,config) {
    //_showLoading = showLoading;
    //axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        //  axios.post(url, qs.stringify(params))   //
        axios.post(url, params,config)
            .then(response => {
                // if (response.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                resolve(response.data);
            }, err => {
                // if (err.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                reject(err.data && err.data.message ? err.data.message : '网络好像出了点问题x!');
            })
            .catch((error) => {
                reject(error)
            })
    })
}

function del(url, params) {
    //_showLoading = showLoading;
    //axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        //  axios.post(url, qs.stringify(params))   //
        axios.delete(url,{ data: params})
            .then(response => {
                // if (response.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                resolve(response.data);
            }, err => {
                // if (err.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                reject(err.data && err.data.message ? err.data.message : '网络好像出了点问题!');
            })
            .catch((error) => {
                reject(error)
            })
    })
}

function put(url, params) {
    //_showLoading = showLoading;
    //axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        //  axios.post(url, qs.stringify(params))   //
        axios.put(url, params)
            .then(response => {
                // if (response.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                resolve(response.data);
            }, err => {
                // if (err.status == 202) {
                //     getNewToken(() => { post(url, params, _showLoading); });
                //     return;
                // }
                reject(err.data && err.data.message ? err.data.message : '网络好像出了点问题!');
            })
            .catch((error) => {
                reject(error)
            })
    })
}

 //_showLoading=true异步请求时会显示遮罩层,_showLoading=字符串，异步请求时遮罩层显示当前字符串
function get(url, param) {
    //_showLoading = showLoading;
   // axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        axios.get(url, { params: param })
            .then(response => {
                //console.log(response)
                // if (response.status == 202) {
                //     getNewToken(() => { get(url, param, _showLoading); });
                //     return;
                // }
                resolve(response.data)
            }, err => {
                // if (err.status == 202) {
                //     getNewToken(() => { get(url, param, _showLoading); });
                //     return;
                // }
                
               if (err.status  == 401) {
                  console.log(err)
                  $httpVue.$Message.error(err.data.msg);
                  $httpVue.$router.push({ path: '/login', params: { r: Math.random() } });
                }
               // reject(err)
            })
            .catch((error) => {
                console.log(error)
                //$httpVue.$Message.success('这是一条成功消息');
                
                reject(error)
            })
    })
}

function stream(url, param) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: param, responseType: 'blob' })
            .then(response => {
                resolve(response)
            }, err => {
               if (err.status  == 401) {
                  console.log(err)
                  $httpVue.$Message.error(err.data.msg);
                  $httpVue.$router.push({ path: '/login', params: { r: Math.random() } });
                }else{
                    reject(err)
                }
            })
            .catch((error) => {
                reject(error)
            })
    })
}





let $httpVue = null;

function init(vue) {
    console.log("进入这http")
    $httpVue = vue;

    //console.log("token:"+$httpVue.$store.getters.getToken())
}
export default { post, get,del,put,stream,init } 


// WEBPACK FOOTER //
// ./src/api/http.js